import React from "react";
import Page from "./Page";
import logo from "../../assets/TMDWhite.png";
import copy from "../copy.json";

const Header = () => {
  return (
    <Page background={`url('${copy.intropic}') #0008`}>
      <div className="header-container">
        <div className="header-main">
          <img src={logo} className="header-logo" onClick={(e) => {e.preventDefault(); window.location.href='https://michigandaily.com';}}/>
          {copy.hed}
        </div>
        <div className="header-description">{copy.intro}</div>
        <div className="header-scroll">
          <span className="chevron bottom"></span>
        </div>
      </div>
    </Page>
  );
};

export default Header;
